'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useAuthStore } from '@/stores/authStore';

export function useRoles() {
  const user = useAuthStore((state) => state.user);

  function hasRole(roleName: string): boolean {
    if (!user?.roles) return false;

    return user.roles.includes(roleName);
  }

  function hasAnyRole(roleNames: string[]): boolean {
    return roleNames.some((roleName) => hasRole(roleName));
  }

  function hasAllRoles(roleNames: string[]): boolean {
    return roleNames.every((roleName) => hasRole(roleName));
  }

  return {
    hasRole,
    hasAnyRole,
    hasAllRoles,
    userRoles: user?.roles || [],
  };
}
